import { Grow, IconButton, InputAdornment, TextField as MuiTextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { forwardRef, useEffect, useState } from "react";
import styled from "styled-components";
import { KvixIcon } from "../../icons";
const useStyles = makeStyles((theme) => ({
    hideTypeHidden: {
        display: "none"
    }
}));
const Container = styled.div `
  display: inline;
  position: relative;
`;
const Icon = styled.div `
  position: absolute;
  display: inline-flex;
  top: -0.4em;
  right: -0.5em;

  svg {
    position: absolute;
  }

  &:before {
    content: "";
    width: 1.25em;
    height: 1.25em;
    margin: 0.125em;
    border-radius: 50%;
    background-color: white;
    transform: scale(0.75);
  }
`;
export const TextField = forwardRef((props, ref) => {
    const classes = useStyles();
    const [showPassword, setShowPassword] = useState(props.type !== "password");
    useEffect(() => {
        setShowPassword(props.type !== "password");
    }, [props.type]);
    const { label, placeholder, helperText, required, disabled, error, type, name, value, autoFocus, multiline, rows, rowsMax, shrink, minLength, maxLength, autoComplete, inputMode, pattern, className, tabIndex, fullWidth, icon, iconPosition, InputProps, onClick, onChange, onKeyPress, onKeyDown, onBlur, onFocus } = props;
    const togglePasswordVisiblity = () => {
        setShowPassword((previous) => !previous);
    };
    const getType = () => {
        if (type === "password") {
            return showPassword ? "text" : "password";
        }
        return type;
    };
    const getHelperText = () => {
        if (error) {
            return typeof error === "string" ? error : null;
        }
        return helperText;
    };
    const position = iconPosition || "start";
    let startAdornment = null;
    let endAdornment = null;
    if (type === "password") {
        endAdornment = (React.createElement(InputAdornment, { position: "end" },
            React.createElement(IconButton, { edge: "end", "aria-label": "toggle password visibility", onClick: togglePasswordVisiblity }, showPassword ? React.createElement(KvixIcon.Eye.Visible, null) : React.createElement(KvixIcon.Eye.Hidden, null))));
    }
    if (icon && position === "start") {
        startAdornment = React.createElement(InputAdornment, { position: "start" }, icon);
    }
    if (icon && position === "end") {
        endAdornment = React.createElement(InputAdornment, { position: "end" }, icon);
    }
    return (React.createElement("div", { className: getType() === "hidden" ? classes.hideTypeHidden : null },
        React.createElement(Container, null,
            React.createElement(MuiTextField, { label: label, placeholder: placeholder, required: required, disabled: disabled, error: !!error, type: getType(), name: name, value: value, className: className, tabIndex: tabIndex, fullWidth: fullWidth, onClick: onClick, onChange: onChange, onKeyPress: onKeyPress, onKeyDown: onKeyDown, onBlur: onBlur, onFocus: onFocus, autoFocus: autoFocus, autoComplete: autoComplete, inputMode: inputMode, multiline: multiline, rows: rows, rowsMax: rowsMax, helperText: getHelperText(), variant: "outlined", inputRef: ref, inputProps: {
                    minLength,
                    maxLength,
                    pattern
                }, InputProps: Object.assign({ startAdornment,
                    endAdornment }, InputProps), InputLabelProps: {
                    shrink
                } }),
            React.createElement(Grow, { in: !!error },
                React.createElement(Icon, null,
                    React.createElement(KvixIcon.Error, { color: "error" }))))));
});
//# sourceMappingURL=TextField.js.map